<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        <div class="player-activity-container">
            @if (desktop) {
                <div class="targeted-promotions-layout row">
                    <div class="col12 col-md-8">
                        <tp-calculate-result></tp-calculate-result>
                        <tp-results-prize-group [showCheckButton]="vm.showCheckButton" [resultsContent]="vm.resultsContent"></tp-results-prize-group>
                        @if (vm.resultsPrizesLength !== 1) {
                            <tp-results-info-group [resultsInfos$]="resultsInfos$"></tp-results-info-group>
                        }
                        <base-details-terms-conditions
                            [detailsContent]="vm.baseDetailsContent"
                            [clientContent]="vm.commonContentMessages"></base-details-terms-conditions>
                    </div>
                    <div class="mt-2 col12 col-md-4">
                        <tp-cross-selling></tp-cross-selling>
                    </div>
                </div>
            }
            @if (!desktop) {
                <div class="targeted-promotions-layout">
                    <div class="col">
                        <tp-calculate-result></tp-calculate-result>
                        <tp-results-prize-group [showCheckButton]="vm.showCheckButton" [resultsContent]="vm.resultsContent"></tp-results-prize-group>
                        @if (vm.resultsPrizesLength !== 1) {
                            <tp-results-info-group [resultsInfos$]="resultsInfos$"></tp-results-info-group>
                        }
                        <tp-cross-selling></tp-cross-selling>
                        <base-details-terms-conditions
                            [detailsContent]="vm.baseDetailsContent"
                            [clientContent]="vm.commonContentMessages"></base-details-terms-conditions>
                    </div>
                </div>
            }
        </div>
    }
</ng-container>
